import { render } from "./HomeFeatures.vue?vue&type=template&id=0899d6a4&scoped=true&ts=true"
import script from "./HomeFeatures.vue?vue&type=script&lang=ts"
export * from "./HomeFeatures.vue?vue&type=script&lang=ts"

import "./HomeFeatures.vue?vue&type=style&index=0&id=0899d6a4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0899d6a4"]])

export default __exports__